import { render } from "./MoonIcon.vue?vue&type=template&id=6a0a63d0"
const script = {}
script.render = render

export default script